import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserInfoService } from '../services/user-info.service';
import { ZpDataService } from '../services/zp-data.service';
import { IUser } from '../models/user.model';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { SideNavBarVisibilityService } from '../services/side-nav-bar-visibility.service';
import { DelegateHelpers } from '../helpers/delegate-helpers';
import { GetInfoAndPassService } from '../services/get-info-and-pass.service';
import { ThemeService } from '../theme/theme-service.service';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss'],
  host: {
    "(window:click)": "closeFromOutside()"
  }
})
export class TopNavComponent implements OnInit, OnDestroy {
  public loggedIn = false;
  public myUser: IUser;
  public showSideNav = 'bottom';
  public isUser = false;
  public isLogin = false;
  public isDelegate = false;
  public statusScdMenu = false;
  public chosenNav: string;
  public chosenNavSharedPlan: string;
  public mySharedPlans: {}[];
  public subscription: Subscription;
  public subscription1: Subscription;
  public subscription2: Subscription;
  public subscription3: Subscription;
  public subscription4: Promise<void>;
  public subscription5: Subscription;
  public iAmADelegate;
  public myCategoriesLinkList: {}[] = [];
  public assetsCount = 0;
  public debtsCount = 0;
  public myDailyLifeCount = 0;
  public myDigitalLifeCount = 0;
  public wishesCount = 0;
  public delegatesCount = 0;
  public sumarriesCount = 0;
  public dataIsLoaded: boolean = false;
  public activatePlan = [];
  public statusNav: boolean;
  public openSharedPlan = undefined;
  public id: any;
  public hasPlan: any;
  public href: string = "";
  public refCode: any;
  public logoUrl: any;
  public user: any;
  public logoSponsor: boolean;
  public company: string;
  public sponsorFirstName: string;
  public sponsorLastName: string;
  public hideSponsor: any;
  public mobileScreen: boolean;
  public sponsorMobileScreen: boolean;
  public statusAttachments;
  public avatarUrl;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public email="";

  constructor(private userInfo: UserInfoService,
    private route: ActivatedRoute,
    private router: Router,
    private ZpDataService: ZpDataService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private delegateHelpers: DelegateHelpers,
    private getInfoAndPassService: GetInfoAndPassService, public themeService: ThemeService) {
    this.subscription5 = this.getInfoAndPassService.accessRightSection.subscribe((data) => {
      this.statusAttachments = data;
    });
  }

  async ngOnInit() {
    this.activeTheme = this.themeService.active
    if (this.activeTheme.name != 'defaultTheme') {
      this.isDefaultTheme = false;
    }
    this.href = this.router.url;
    this.statusScdMenu = false;
    // this.updateScreen();

    if (window.screen.width <= 1100) {
      this.mobileScreen = true
    } else {
      this.mobileScreen = false
    }

    this.subscription = this.userInfo.getMessage().subscribe(user => {
      if (user && user != 'null' && user.length > 0) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
      try {
        this.myUser = JSON.parse(user);
      } catch {
      }
    });

    this.subscription1 = this.userInfo.getMessage().subscribe(async user => {
      this.myUser = JSON.parse(user);
      if (this.myUser.userType == 'professional') {
        this.showSideNav = 'professional';
      }
      if (this.myUser.userType == 'professionalManager') {
        this.showSideNav = 'professionalManager';
      }
      if (this.myUser.userType == 'admin') {
        this.showSideNav = 'admin';
      }
    });

    this.subscription2 = this.sideNavBarVisibilityService.getMessage().subscribe(async visibility => {
      let myUser = this.ZpDataService.getItemUser(this.id, 'users');
      this.hasPlan = await this.ZpDataService.getPlan(myUser['Id']);
      if (this.hasPlan || (!this.hasPlan && this.mySharedPlans && this.mySharedPlans.length > 0 && this.myUser.userType == 'planHolder')) {
        this.showSideNav = 'bottom'
      } else if (!this.hasPlan && this.mySharedPlans && this.mySharedPlans.length > 0 && this.myUser.userType != 'planHolder') {
        this.showSideNav = 'top'
      }

    });

    this.subscription3 = this.ZpDataService.getMessageNotAsync().subscribe(async message => {
      await this.updateCount();
    });

    this.subscription4 = this.ZpDataService.getUser().then(async user => {
      this.user = user;
      this.refCode = user.refCode;
      await this.ZpDataService.setRefCode(this.refCode);
      this.logoUrl = await this.ZpDataService.getLogoUrl(user.refCode);
      if (this.logoUrl && this.statusAttachments != 'empty') {
        this.logoSponsor = true;
      } else {
        this.logoSponsor = false;
        // console.log('No logo.')
      }
      if (this.logoUrl && !this.mobileScreen) {
        this.sponsorMobileScreen = false;
      }
      this.company = this.ZpDataService.getRefCodeInfo() && this.ZpDataService.getRefCodeInfo().company;
      this.sponsorFirstName = this.ZpDataService.getRefCodeInfo() && this.ZpDataService.getRefCodeInfo().firstName;
      this.sponsorLastName = this.ZpDataService.getRefCodeInfo() && this.ZpDataService.getRefCodeInfo().lastName;
      this.hideSponsor = this.ZpDataService.getRefCodeInfo() && this.ZpDataService.getRefCodeInfo().hideSponsor;
    });

    this.mySharedPlans = await this.ZpDataService.getSharedPlans(this.myUser);
    console.log('mySharedPlans - ', this.mySharedPlans)
    // add into a new
    this.dataIsLoaded = true;
  }

  defaultTheme() {
    this.themeService.setDefaultTheme();
  }

  blueTheme() {
    this.themeService.setBlueTheme();
  }

  lifeFileTheme() {
    this.themeService.setlifeFileTheme();
  }

  pemTheme() {
    this.themeService.setPemTheme();
  }

  palmersTheme() {
    this.themeService.setPalmersTheme();
  }

  async getData() {
    this.updateCount();
  }

  async updateCount() {
    let categoryCount = await this.ZpDataService.getAllPlanCategoriesCount(this.myUser.Id) as [];
    let delegatesCount = await this.ZpDataService.getDelegatesCount(this.myUser.Id);
    this.assetsCount = categoryCount.find(category => category['categoryName'] == 'my assets')['count'];
    this.debtsCount = categoryCount.find(category => category['categoryName'] == 'my debts')['count'];
    this.myDailyLifeCount = categoryCount.find(category => category['categoryName'] == 'my daily life')['count'];
    this.myDigitalLifeCount = categoryCount.find(category => category['categoryName'] == 'my digital life')['count'];
    this.wishesCount = categoryCount.find(category => category['categoryName'] == 'my wishes')['count'];
    this.delegatesCount = delegatesCount;
  }

  async goCreatePlan() {
    let result = await this.ZpDataService.createPlanToDelegate();
    if (result) {
      this.router.navigate(['/payment-choose-plan']);
      this.showSideNav = 'bottom';
    }
  }

  async showSharedPlanSummary(chosenPlanId) {
    this.redirectTo('/shared-plan-summary/' + chosenPlanId);
  }

  async refresh() {
    await this.ZpDataService.revalidateCache();
    this.ZpDataService.changeMessage(JSON.stringify({ "cache revalidated": true }));
  }

  redirectTo(url: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([url]));
  }

  async seeMyPlan($event, section) {
    if (this.chosenNavSharedPlan || this.openSharedPlan) {
      this.chosenNavSharedPlan = null;
      this.openSharedPlan = undefined;
    }
    this.openSharedPlan = undefined;
    this.chosenNav = section;
    this.statusNav = !this.statusNav;
    if (this.statusNav) {
      this.sideNavBarVisibilityService.hideOnMobile = true;
    } else {
      this.sideNavBarVisibilityService.hideOnMobile = false;
    }
    if (this.myUser.sharedPlanUserId) {
      this.myUser.sharedPlanUserId = null;
      this.myUser.delegate = null;
      this.refresh();
      await this.userInfo.changeMessage(JSON.stringify(this.myUser));
    } else {
      await this.userInfo.changeMessage(JSON.stringify(this.myUser));
    }
    switch (section) {
      case 'dashboard':
        this.router.navigate(['/my-dashboard']);
        break;
      case 'delegates':
        this.router.navigate(['/delegates']);
        break;
      case 'assets':
        this.redirectTo('/my-assets/' + this.myUser.Id);
        break;
      case 'debts':
        this.redirectTo('/my-debts/' + this.myUser.Id);
        break;
      case 'daily life':
        this.redirectTo('/my-daily-life/' + this.myUser.Id);
        break;
      case 'digital life':
          this.redirectTo('/my-digital-life/' + this.myUser.Id);
        break;
      case 'digital life':
          this.redirectTo('/my-digital-life/' + this.myUser.Id);
        break;
      case 'wishes':
        this.redirectTo('/my-wishes/' + this.myUser.Id);
        break;
      case 'summaries':
        this.redirectTo('/financial-summaries/');
        break;
    }
  }

  async seeSharedPlan($event, section, chosenPlan) {
    console.log('chosenPlan', chosenPlan);
    sessionStorage.setItem('chosenSharedPlan', JSON.stringify(chosenPlan));
    if (this.chosenNav) {
      this.chosenNav = null;
    }
    this.chosenNavSharedPlan = section;
    this.statusNav = !this.statusNav;
    if (this.statusNav) {
      this.sideNavBarVisibilityService.hideOnMobile = true;
    } else {
      this.sideNavBarVisibilityService.hideOnMobile = false;
    }
    if (this.myUser) {
      console.log(this.myUser)
      this.myUser.sharedPlanUserId;
      this.myUser.delegate;
      this.refresh();
    }
    switch (section) {
      case 'dashboard':
        await this.delegateHelpers.delegateChooseSharedPlan(chosenPlan, this.myUser);
        this.router.navigate(['/my-dashboard/' + chosenPlan['clientId']]);
        break;
        case 'assets':
          if (chosenPlan['assetsPermission'] != 'now' &&
          chosenPlan['assetsPermission'] != 'contributor') {
            this.router.navigate(['/request-access']);
            break;
          }
          await this.delegateHelpers.delegateChooseSharedPlan(chosenPlan, this.myUser);
          console.log('chosanPlan', chosenPlan);
          console.log('myUser - ', this.myUser)
        this.router.navigate(['/my-assets/' + chosenPlan['clientId']]);
        break;
      case 'debts':
        if (chosenPlan['debtsPermission'] != 'now' &&
          chosenPlan['debtsPermission'] != 'contributor') {
          this.router.navigate(['/request-access']);
          break;
        }
        await this.delegateHelpers.delegateChooseSharedPlan(chosenPlan, this.myUser);
        this.router.navigate(['/my-debts/' + chosenPlan['clientId']]);
        break;
      case 'daily life':
        if (chosenPlan['dailyLifePermission'] != 'now' &&
          chosenPlan['dailyLifePermission'] != 'contributor') {
          this.router.navigate(['/request-access']);
          break;
        }
        await this.delegateHelpers.delegateChooseSharedPlan(chosenPlan, this.myUser);
        this.router.navigate(['/my-daily-life/' + chosenPlan['clientId']]);
        break;
      case 'digital life':
        if (chosenPlan['digitalLifePermission'] != 'now' &&
          chosenPlan['digitalLifePermission'] != 'contributor') {
          this.router.navigate(['/request-access']);
          break;
        }
        await this.delegateHelpers.delegateChooseSharedPlan(chosenPlan, this.myUser);
        this.router.navigate(['/my-digital-life/' + chosenPlan['clientId']]);
        break;
      case 'wishes':
        if (chosenPlan['wishesPermission'] != 'now' &&
          chosenPlan['wishesPermission'] != 'contributor') {
          this.router.navigate(['/request-access']);
          break;
        }
        await this.delegateHelpers.delegateChooseSharedPlan(chosenPlan, this.myUser);
        this.router.navigate(['/my-wishes/' + chosenPlan['clientId']]);
        break;
      case 'summaries':
        if ((chosenPlan['assetsPermission'] != 'now' &&
          chosenPlan['assetsPermission'] != 'contributor') && (chosenPlan['debtsPermission'] != 'now' &&
            chosenPlan['debtsPermission'] != 'contributor') && (chosenPlan['dailyLifePermission'] != 'now' &&
              chosenPlan['dailyLifePermission'] != 'contributor') && (chosenPlan['digitalLifePermission'] != 'now' &&
                chosenPlan['digitalLifePermission'] != 'contributor'))

              {
          this.router.navigate(['/request-access']);
          break;
        }
        await this.delegateHelpers.delegateChooseSharedPlan(chosenPlan, this.myUser);
        this.router.navigate(['/financial-summaries']);
        break;
    }
  }

  seeAdminDashboard($event, section) {
    this.chosenNav = section;
    this.statusNav = !this.statusNav;
    if (this.statusNav) {
      this.sideNavBarVisibilityService.hideOnMobile = true;
    } else {
      this.sideNavBarVisibilityService.hideOnMobile = false;
    }
    switch (section) {
      case 'accounts':
        this.router.navigate(['/accounts']);
        break;
      case 'professionals':
        this.router.navigate(['/professionals'])
        break;
      case 'partners':
        this.router.navigate(['/partners'])
        break;
      case 'analytics':
        this.router.navigate(['/analytics'])
        break;
      case 'lists':
        this.router.navigate(['/lists'])
        break;
      case 'monitoring':
        this.statusNav = !this.statusNav;
        this.router.navigate(['/monitoring'])
        break;
      case 'copy editor':
        this.router.navigate(['/copyeditor'])
        break;
      case 'mail rules':
        this.router.navigate(['/mail-rules'])
        break;
      case 'resources':
        this.router.navigate(['/resources'])
        break;
      case 'suggestion rules':
        this.router.navigate(['/suggestion-rules'])
        break;
      case 'roles':
        this.router.navigate(['/roles'])
        break;
      case 'mail log':
        this.router.navigate(['/mail-log'])
        break;
      case 'events log':
        this.router.navigate(['/events-log'])
        break;
      case 'ref codes':
        this.router.navigate(['/refcodes'])
        break;
      case 'unlock request':
        this.router.navigate(['/unlock-request'])
        break;
      case 'mail queue':
        this.router.navigate(['/mail-queue'])
        break;

    }
  }

  openScdMenu($event) {
    $event.stopPropagation();
    this.statusScdMenu = !this.statusScdMenu;
  }

  closeFromOutside() {
    this.statusScdMenu = false;
  }

  openSideNav() {
    this.statusNav = !this.statusNav;
    if (this.statusNav) {
      this.sideNavBarVisibilityService.hideOnMobile = true;
    } else {
      this.sideNavBarVisibilityService.hideOnMobile = false;
    }
  }

  goToProfessionalHomePage() {
    this.openSharedPlan = undefined;
    if (this.myUser.userType == 'professional') {
      this.router.navigate(['/professional-home-page'])
    }
    if (this.myUser.userType == 'professionalManager') {
      this.router.navigate(['/professional-manager-home-page'])
    }
  }

  goToFromScdMenu(link) {
    switch (link) {
      case 'plan-review':
        this.router.navigate(['/plan-review']);
        this.chosenNav = null;
        break;
      case 'request-access':
        this.router.navigate(['/request-access']);
        this.chosenNav = null;
        break;
      case 'delegate':
        this.router.navigate(['/dynamicformdataentry/delegate_1']);
        this.chosenNav = null;
        break;
      case 'deleted-items':
        this.router.navigate(['/deleted-items']);
        this.chosenNav = null;
        break;
      case 'account-settings':
        this.router.navigate(['/account-settings']);
        this.chosenNav = null;
        break;
      case 'security-page':
        this.router.navigate(['/security-page']);
        this.chosenNav = null;
        break;
    }
  }

  ngOnDestroy() {
    this.statusScdMenu = false;
  }

  logout() {
    this.statusScdMenu = false;
    this.ZpDataService.logout();
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
  }

  activateClass(sharedPlan: any, index: any) {
    sharedPlan.sharedPlanInfoToggled = !sharedPlan.sharedPlanInfoToggled;
    sharedPlan.activeArrow = !sharedPlan.activeArrow;
    this.showSharedPlanSummary(sharedPlan.Id);
    this.openSharedPlan = index;
    if (this.chosenNav) {
      this.chosenNav = null;
    }
  }

  openPortal() {
    var chargebeeInstance = window['Chargebee'].init({
      site: this.ZpDataService.chargeBeeSite
    });
    let self = this;
    chargebeeInstance.setPortalSession(() => {
      // Hit your end point that returns portal session object as response
      // This sample end point will call the below api
      // https://apidocs.chargebee.com/docs/api/portal_sessions#create_a_portal_session
      return self.ZpDataService.chargeBeePortal({});
    });
    window.setTimeout(function () {
      chargebeeInstance.createChargebeePortal().open({
        loaded: () => {

        },
        close: () => {

        },
        // paymentSourceAdd: (status) => {
        //   console.log("payment source add" + status);
        // },
        // paymentSourceUpdate: (status) => {
        //   console.log("payment source update" + status);
        // },
        // paymentSourceRemove: (status) => {
        //   console.log("payment source removed");
        // },
        // visit: (value) => {
        //   console.log(value);
        // }
      });

    }, 300);
  }
}
